module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/awards/award-list/award-list.component.scss
// module id = ./libs/atenea-cms-brand/src/awards/award-list/award-list.component.scss
// module chunks = main